import { classNameWithModifier } from '@slickdeals/durango/dist/javascript/utilities/css';
import BlueprintComponent from '../core/blueprintComponent';
import './link';
import '../../scss/components/button.scss';
/** The name of the module */
export const name = 'Button';
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-c-button";
    ClassNames["JavaScript"] = "js-button";
})(ClassNames || (ClassNames = {}));
/** Available modifiers for the Button element */
export var modifiers;
(function (modifiers) {
    modifiers["unstyled"] = "unstyled";
    modifiers["primary"] = "primary";
    modifiers["secondary"] = "secondary";
    modifiers["buy"] = "buy";
    modifiers["dealAlert"] = "dealAlert";
    modifiers["primaryText"] = "primaryText";
    modifiers["secondaryText"] = "secondaryText";
    modifiers["xlarge"] = "xlarge";
    modifiers["large"] = "large";
    modifiers["small"] = "small";
    modifiers["link"] = "link";
    modifiers["block"] = "block";
    modifiers["inline"] = "inline";
    modifiers["disabled"] = "disabled";
})(modifiers || (modifiers = {}));
export default class Button extends BlueprintComponent {
    /**
     * Performs any necessary initialization for the component
     */
    async init() {
        super.init();
        if (typeof this.element === 'undefined') {
            this.element = await BlueprintComponent.loadElement(name, this.options);
        }
        if (typeof this.element === 'undefined') {
            throw new Error('Button element is undefined');
        }
    }
    /**
     * Create a button element with an optional text label and style modifiers
     *
     * @param {String} label - The label to apply to the button (if any)
     * @param {String[]} options - Array of modifiers to apply to the new button element
     *
     * @return {ButtonElement}
     */
    static createElement(label = '', options) {
        // Create the HTMLElement to build off of
        const element = document.createElement('button');
        // Add the base class name
        element.classList.add(ClassNames.Default);
        // If there's a label specified, then add it
        if (label) {
            element.append(document.createTextNode(label));
        }
        // Add any modifier classes
        options.forEach((option) => {
            if (modifiers[option]) {
                element.classList.add(classNameWithModifier(ClassNames.Default, modifiers[option]));
            }
        });
        return element;
    }
}
// Create button components in the hydration queue
BlueprintComponent.instantiate(name);
